import React from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router';
import Form from '../../../molecules/Form';

// Components
import UserRegistrationFormTemplate from './UserRegistrationFormTemplate';
import { ParameterShape } from '../../../../lib/shapes/FormActionShape';

function UserRegistrationForm({ method, url, params }) {
  const navigate = useNavigate();

  return (
    <Form
      id="user-registration-request-form"
      model={{ method, url, params }}
      onSuccess={(response) => {
        if (response && response.status === 200 && response.data.url) {
          setTimeout(() => {
            navigate(response.data.url);
          }, 3000);
        }
      }}
    >
      <UserRegistrationFormTemplate />
    </Form>
  );
}

UserRegistrationForm.propTypes = {
  params: PropTypes.arrayOf(ParameterShape).isRequired,
  method: PropTypes.oneOf(['POST']).isRequired,
  url: PropTypes.string.isRequired,
};

export default UserRegistrationForm;
